// Mobile nav toggle
const burger = document.querySelector('.header__burger');
const mobileNav = document.querySelector('.header__mobile-nav');
if (burger && mobileNav) {
  burger.addEventListener('click', () => {
    const open = mobileNav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open);
    mobileNav.setAttribute('aria-hidden', !open);
  });
}

// Qty buttons
document.addEventListener('click', e => {
  const btn = e.target.closest('.qty-btn');
  if (!btn) return;
  const input = btn.parentElement.querySelector('.qty-input');
  if (!input) return;
  const val = parseInt(input.value, 10) || 1;
  if (btn.dataset.action === 'plus') input.value = val + 1;
  if (btn.dataset.action === 'minus' && val > 1) input.value = val - 1;
});

// Product variant selector
const optionBtns = document.querySelectorAll('.option-btn');
if (optionBtns.length) {
  optionBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = btn.dataset.optionIndex;
      btn.closest('.product-page__option-values').querySelectorAll('.option-btn').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
    });
  });
}

// Cart count update after add-to-cart form submit
const productForm = document.querySelector('#product-form');
if (productForm) {
  productForm.addEventListener('submit', async e => {
    e.preventDefault();
    const data = new FormData(productForm);
    data.append('sections', 'cart-icon-bubble');
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: data });
      await res.json();
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const counter = document.querySelector('.header__cart-count');
      if (counter) {
        counter.textContent = cart.item_count;
        counter.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch (err) {
      productForm.submit();
    }
  });
}
